module.exports = __webpack_public_path__ + "media/images/story/icon/avatarEmpty-642b779740adc8ccd18e262697807dae.svg";